import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { SimpleTable } from '~/components';
import { t, number } from '~/helpers';
import api from '~/services/api';
import { ContainerForm } from './styles';
export default function MyForm({ data, reference, close }) {

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        rgpIntegracaoSiad: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        codPosto: data.poco_codigo,
        status: param.rgpIntegracaoSiad,
      };

      await api.put('postocontrolesiad', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>

        <p>Dados do Recebimento Provisório</p>

        <SimpleTable

          url="operacaoprerecebimentolistas"
          cells={[
            {
              id: 'prre_codigo',
              label: 'Recebimento Provisório',
            },
            {
              id: 'prri_nf',
              label: 'Nota Fiscal:',
            },
            {
              id: 'prod_display',
              label: 'Produto:',
            },
            {
              id: 'prri_volume_nf',
              label: 'Volume:',
              align: 'right',
              format: (value) => number(value, 1),
            },
            {
              id: 'orga_nome',
              label: 'Órgão:',
            },

          ]}

          unique={['prri_nf']}
          form={MyForm}
          onCreate={false}
          onUpdate={false}
          onDelete={false}
          title={'Recebimento Provisório'}
          restProps={''}
          query={{
            wherefield: ['prre_codigo'],
            valuewherefield: [data.prre_codigo],
            typewherefield: ['EQUALS'],
          }}
        />


        <p>Tanques Receptores</p>
        <SimpleTable

          url="operacaoprerecebimentotanquesreceptoreslistas"
          cells={[
            {
              id: 'tafi_codigo',
              label: 'Tanque:',
            },
            {
              id: 'prta_volume_inicial',
              label: 'Vol.Inicial:',
              align: 'right',
              format: (value) => number(value, 1),
            },
            {
              id: 'prta_volume_final',
              label: 'Vol.Final:',
              align: 'right',
              format: (value) => number(value, 1),
            },
            {
              id: 'prta_modoleitura_ini_str',
              label: 'Modo Leitura Inicial:',
            },
            {
              id: 'prta_modoleitura_fim_str',
              label: 'Modo Leitura Final:',
            },
            {
              id: 'prta_volume_medido',
              label: 'Vol.Medido:',
              align: 'right',
              format: (value) => number(value, 1),
            },
            {
              id: 'tafi_capacidade',
              label: 'Capacidade Tanque:',
              align: 'right',
              format: (value) => number(value, 1),
            },


          ]}

          unique={['tafi_codigo']}
          form={MyForm}
          onCreate={false}
          onUpdate={false}
          onDelete={false}
          title={'Tanques Receptores'}
          restProps={''}
          query={{
            wherefield: ['prre_codigo'],
            valuewherefield: [data.prre_codigo],
            typewherefield: ['EQUALS'],
          }}
        />


      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
